export default __webpack_public_path__ + "static/media/h5datasourcemgr.86dbcd11.svg";